import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from 'moment-timezone';

const DateFilter = ({groupByModes, onFilterChange, from, to, groupBy, addButton = false, onAddClick}) => {
    const [fromDate, setFromDate] = useState(from);
    const [toDate, setToDate] = useState(to);
    const [groupByMode, setGroupByMode] = useState(groupBy ? groupBy : groupByModes[0].value);

    let cols = 6
    let extraCols = 0
    let groupByCols = 8
    let addButtonCols = 4

    if(groupByModes && addButton) {
      cols = 4
      extraCols = 4
    } else {
      if(groupByModes) {
        cols = 4
        extraCols = 4
        groupByCols = 12
      }
      if(addButton) {
        cols = 4
        extraCols = 4
        addButtonCols = 12 
      }
    }

    const onAdd = () => {
      if(onAddClick) onAddClick()
    }

    useEffect(() => {
      let from = moment(fromDate)
      let to = moment(toDate).set({hour:0, minute:0, second:0, millisecond:0})

      if(to.isAfter(from)) {
        if(onFilterChange) onFilterChange(fromDate, toDate, groupByMode)
      } else {
        console.log("error" + from.isAfter(to), from.format('YYYY-MM-DD HH:mm:ss'), to.format('YYYY-MM-DD HH:mm:ss') )
      }
    }, [fromDate, toDate, groupByMode])


    return (
      <Card>
        <CardBody>
          <Row>
            <Col sm="12" md={cols}>
                <div>
                  <b>Data inizio</b>
                  <Datetime
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    closeOnSelect={true}
                    value={moment(fromDate)}
                    inputProps={{ placeholder: "seleziona una data..." }}
                    onChange={(value) => {
                      // console.log(value.format("YYYY/MM/DD"))
                      if(value instanceof moment) {
                        setFromDate(value.format('YYYY-MM-DD HH:mm:ss'))
                      }
                    }}
                  />
                </div>
            </Col>
            <Col sm="12" md={cols}>
              <div>
                <b>Data fine</b>
                <Datetime
                  dateFormat="DD/MM/YYYY"
                  timeFormat={false}
                  closeOnSelect={true}
                  value={moment(toDate)}
                  inputProps={{ placeholder: "seleziona una data..." }}
                  onChange={(value) => {
                    //console.log(value.format("YYYY/MM/DD hh:mm:ss"))
                    if(value instanceof moment) {
                      setToDate(value.format('YYYY-MM-DD HH:mm:ss'))
                    }
                  }}
                />
              </div>
            </Col>
            {
              groupByModes || addButton 
              ? <Col sm="12" md={extraCols}>
                <Row>
                  {
                    groupByModes 
                    ? <Col sm="12" md={groupByCols}>
                        <b>Raggruppamento</b>
                        <Input type="select" id="group_by" 
                          value={groupByMode} 
                          onChange={(e) => setGroupByMode(e.target.value)} 
                        >
                          {groupByModes.map((groupBy) => (
                            <option key={groupBy.value} value={groupBy.value}>{groupBy.label}</option>
                          ))}
                        </Input>
                      </Col>
                    : null
                  }
                  {
                    addButton 
                    ? <Col sm="12" md={addButtonCols}>
                        <div>&nbsp;</div>
                        <Button id="new_pos_btn" color="primary" onClick={onAdd} >
                          <span className="fas fa-plus"></span>
                        </Button>
                      </Col>
                    : null
                  }
                </Row>
                
              </Col>
              : null
            }
          </Row>
          {/* { 
            fromDate.isBefore(toDate) 
            ? <Row>
                <Col md="12" className="text-danger">Range date non valido, la <b>data finale</b> precede quella <b>iniziale</b> {fromDate.isAfter(toDate)}</Col> 
              </Row>
            : null 
          } */}
        </CardBody>
      </Card>    
    );
};

export default DateFilter;